import React, { useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Alert } from './ui';
import { submitFeedback } from '../services/feedback';
import { useLocation } from 'react-router-dom';

export default function ReportProblemButton() {
  const [open, setOpen] = useState(false);
  const [area, setArea] = useState('General UI');
  const [severity, setSeverity] = useState<'low'|'medium'|'high'>('low');
  const [blocks, setBlocks] = useState(false);
  const [notes, setNotes] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [successId, setSuccessId] = useState<string | null>(null);
  const location = useLocation();

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitting(true);
    setError(null);
    setSuccessId(null);
    try {
      const payload = {
        area,
        severity,
        blocks_progress: blocks,
        notes,
        route: location.pathname,
        frontend_version: (window as any).__APP_VERSION__ || undefined,
      };
      const res = await submitFeedback(payload);
      setSuccessId(res.id);
      setNotes('');
      setBlocks(false);
      setSeverity('low');
      setArea('General UI');
    } catch (err: any) {
      setError(err?.message || 'Failed to submit feedback');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="px-3 py-1 bg-red-600 text-white rounded hover:bg-red-500 text-sm"
        title="Report A Problem"
      >
        Report A Problem
      </button>
      <Modal isOpen={open} onClose={() => setOpen(false)}>
        <ModalHeader>
          Report a Problem
        </ModalHeader>
        <ModalBody>
          {error && <Alert variant="error" className="mb-3">{error}</Alert>}
          {successId && <Alert variant="success" className="mb-3">Thanks! Report ID: {successId}</Alert>}
          <form onSubmit={onSubmit}>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm text-gray-300 mb-1">Area</label>
                <select
                  className="w-full bg-gray-900 border border-gray-700 rounded px-3 py-2 text-white"
                  value={area}
                  onChange={e => setArea(e.target.value)}
                >
                  {['General UI', 'Labs List', 'Lab Detail', 'Run Detail', 'SSH / Connectivity', 'Grading', 'Admin', 'Instructor'].map(a => (
                    <option key={a} value={a}>{a}</option>
                  ))}
                </select>
              </div>
              <div>
                <label className="block text-sm text-gray-300 mb-1">Severity</label>
                <select
                  className="w-full bg-gray-900 border border-gray-700 rounded px-3 py-2 text-white"
                  value={severity}
                  onChange={e => setSeverity(e.target.value as any)}
                >
                  <option value="low">Low</option>
                  <option value="medium">Medium</option>
                  <option value="high">High</option>
                </select>
              </div>
            </div>
            <div className="mt-4">
              <label className="inline-flex items-center gap-2 text-sm text-gray-300">
                <input type="checkbox" className="accent-blue-600" checked={blocks} onChange={e => setBlocks(e.target.checked)} />
                This blocks my progress
              </label>
            </div>
            <div className="mt-4">
              <label className="block text-sm text-gray-300 mb-1">Notes</label>
              <textarea
                className="w-full bg-gray-900 border border-gray-700 rounded px-3 py-2 text-white h-28"
                value={notes}
                onChange={e => setNotes(e.target.value)}
                placeholder="Describe what happened and steps to reproduce…"
                required
              />
            </div>
            <div className="mt-4 flex justify-end gap-2">
              <Button type="button" onClick={() => setOpen(false)} disabled={submitting}>
                Close
              </Button>
              <Button type="submit" className="bg-blue-600 hover:bg-blue-700" disabled={submitting || !notes.trim()}>
                {submitting ? 'Submitting…' : 'Submit'}
              </Button>
            </div>
          </form>
        </ModalBody>
        <ModalFooter>
          <div className="text-xs text-gray-400">Route: {location.pathname}</div>
        </ModalFooter>
      </Modal>
    </>
  );
}
